import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, finalize } from 'rxjs';
import { environment } from 'apps/driver-dashboardfe/src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ApiDriverInterfaceService {
    private baseAPIUrl = environment.baseURL;
    private baseAPIUrlV2 = environment.baseURLV2;

    constructor(protected httpClient: HttpClient) {}

    get(url: string, filterParams: any): Observable<any> {
        url = this.baseAPIUrl + url;

        let queryString = '';
        if (filterParams) {
            const fitlerKeys: any[] = Object.keys(filterParams);
            if (fitlerKeys.length > 0) {
                queryString = '?';
            }
            fitlerKeys.forEach((key: any, index) => {
                if (
                    filterParams[key] !== undefined &&
                    filterParams[key] !== null
                ) {
                    if (filterParams[key].toString().length) {
                        queryString += `${key}=${encodeURIComponent(
                            filterParams[key]
                        )}&`;
                    }
                }
            });
            if (
                fitlerKeys.length > 0 &&
                queryString[queryString.length - 1] === '&'
            ) {
                queryString = queryString.slice(0, -1);
            }
        }
        return this.httpClient.get(`${url}${queryString}`).pipe(
            map((body: any) => {
                return body;
            })
        );
    }

    post(url: string, payload: any): Observable<any> {
        url = this.baseAPIUrl + url;
        return this.httpClient.post(url, payload).pipe(
            map((body: any) => {
                return body;
            })
        );
    }

    patch(url: string, payload: any): Observable<any> {
        url = this.baseAPIUrl + url;
        return this.httpClient.patch(url, payload).pipe(
            map((body: any) => {
                return body;
            })
        );
    }

    delete(url: string, id: string, source: String = ''): Observable<any> {
        url = this.baseAPIUrl + url;
        let fullurl;
        id ? (fullurl = `${url}/${id}/`) : (fullurl = `${url}`);

        // Add source to fullurl
        if (source.length > 0) {
            fullurl = `${fullurl}?source=${source}`;
        }

        return this.httpClient.delete(fullurl).pipe(
            map((body: any) => {
                return body;
            })
        );
    }
    postData(url: string, payload: any): Observable<any> {
        url = this.baseAPIUrl + url;
        return this.httpClient
            .post(url, payload, { responseType: 'text' })
            .pipe(
                map((body: any) => {
                    return body;
                })
            );
    }
    saveFormData(url: string, payload: any): Observable<any> {
        url = this.baseAPIUrl + url;
        return this.httpClient
            .post(url, payload, { responseType: 'text' })
            .pipe(
                map((body: any) => {
                    return body;
                })
            );
    }
    deleteFormData(url: string, payload: any): Observable<any> {
        url = this.baseAPIUrl + url;
        const options = {
            body: {
                payload,
            },
        };
        return this.httpClient.patch(url, payload).pipe(
            map((body: any) => {
                return body;
            })
        );
    }

    patchV2(url: string, payload: any): Observable<any> {
        url = this.baseAPIUrlV2 + url;
        return this.httpClient.patch(url, payload).pipe(
            map((body: any) => {
                return body;
            })
        );
    }

    getV2(url: string, filterParams: any): Observable<any> {
        url = this.baseAPIUrlV2 + url;

        let queryString = '';
        if (filterParams) {
            const fitlerKeys: any[] = Object.keys(filterParams);
            if (fitlerKeys.length > 0) {
                queryString = '?';
            }
            fitlerKeys.forEach((key: any, index) => {
                if (
                    filterParams[key] !== undefined &&
                    filterParams[key] !== null
                ) {
                    if (filterParams[key].toString().length) {
                        queryString += `${key}=${encodeURIComponent(
                            filterParams[key]
                        )}&`;
                    }
                }
            });
            if (
                fitlerKeys.length > 0 &&
                queryString[queryString.length - 1] === '&'
            ) {
                queryString = queryString.slice(0, -1);
            }
        }
        return this.httpClient.get(`${url}${queryString}`).pipe(
            map((body: any) => {
                return body;
            })
        );
    }

    postV2(url: string, payload: any): Observable<any> {
        url = this.baseAPIUrlV2 + url;
        return this.httpClient.post(url, payload).pipe(
            map((body: any) => {
                return body;
            })
        );
    }
}
